import React from "react";

/**
 * Global error boundary. Prevents the "white screen of death": if any child
 * component throws during render, we show a friendly recovery screen instead
 * of a blank page. Resets automatically when the route (locationKey) changes.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface for debugging / monitoring
    console.error("ErrorBoundary caught:", error, info);
  }

  componentDidUpdate(prevProps) {
    // When the user navigates to another route, clear the error so the app recovers.
    if (this.state.hasError && prevProps.locationKey !== this.props.locationKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch {
      // no-op
    }
  };

  handleHome = () => {
    try {
      window.location.assign("/app");
    } catch {
      // no-op
    }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary"
        style={{ minHeight: "100vh", background: "#F3F7F3", color: "#0C1F12" }}
        className="flex items-center justify-center p-6"
      >
        <div className="w-full max-w-md text-center">
          <img
            src="/logo-activa.png"
            alt="Activa Capital Privado"
            style={{ width: 56, height: 56, objectFit: "contain", margin: "0 auto" }}
          />
          <h1
            className="mt-6 font-display text-2xl font-black tracking-tight"
            style={{ color: "#0E4D28" }}
          >
            Algo salió mal
          </h1>
          <p className="mt-3 text-sm" style={{ color: "#5B6B61" }}>
            Ocurrió un problema al cargar esta pantalla. No te preocupes, tus datos están
            seguros. Intenta recargar la página o vuelve al inicio.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={this.handleReload}
              data-testid="error-reload"
              className="h-12 px-6 text-sm font-semibold text-white"
              style={{ background: "#0E4D28" }}
            >
              Recargar página
            </button>
            <button
              onClick={this.handleHome}
              data-testid="error-home"
              className="h-12 px-6 text-sm font-semibold"
              style={{ border: "1px solid rgba(12,31,18,0.2)", color: "#0C1F12" }}
            >
              Ir al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}
